<neo-button-toggle-group
  [value]="value"
  (valueChange)="onValueChange($event)"
  [multiple]="multiple()"
  [disabled]="disabled"
  [vertical]="vertical()"
  [size]="size()"
  [buttonWidth]="buttonWidth()"
  [hideSingleSelectionIndicator]="hideSingleSelectionIndicator()"
  [hideMultipleSelectionIndicator]="hideMultipleSelectionIndicator()"
  [attr.aria-label]="ariaLabel()"
>
  @for (vm of optionVms(); track vm.value) {
    <neo-button-toggle
      [value]="vm.value"
      [disabled]="vm.disabled ?? false"
      [autId]="vm.autId"
      [attr.aria-label]="vm.ariaLabel"
    >
      {{ vm.label }}
    </neo-button-toggle>
  }
</neo-button-toggle-group>
